export const categoryHandles = {
  'postansko-sanduce': 'mailbox', 'cuvaj-se-psa': 'dogSign',
  'objekat-je-pod-video-nadzorom': 'surveillance', 'zabranjeno-parkiranje': 'parking',
  'personalizovani-kameni-podmetaci-za-case': 'coasters', 'personalizovani-kokos-otirac': 'doormat', 'pojedinacni-karakteri': 'houseNumber'
};

export function safeImage(value) {
  if (!value || typeof value !== 'string') return '';
  try {
    const url = new URL(value.startsWith('//') ? `https:${value}` : value);
    const allowed = ['cdn.shopify.com', 'www.kucnibrojevi.com', 'kucnibrojevi.com', 'app.fordservisbeograd.rs', 'cdn.customily.com', 'customily.com'];
    return url.protocol === 'https:' && allowed.some(host => url.hostname === host || url.hostname.endsWith(`.${host}`)) ? url.href : '';
  } catch { return ''; }
}

export function sizedImage(value, width) {
  const safe = safeImage(value);
  if (!safe) return '';
  const url = new URL(safe);
  if (url.hostname === 'app.fordservisbeograd.rs' && url.pathname === '/table_designer/file.php' && url.searchParams.get('type') === 'preview_png') url.searchParams.set('w', String(width));
  return url.href;
}

export function humanDesignLabel(key) {
  return ({'Sa strane':'Bočne stranice','Boja table':'Boja podloge','Boja teksta':'Boja natpisa','Dodatni natpis':'Dodatni tekst'})[key] || key;
}

export function humanDesignValue(key, value) {
  const text = String(value == null ? '' : value);
  if (!/boja|materijal|vrata|sa strane|^oblik$|^pismo$|pozicija/i.test(key)) return text;
  const names = {crna:'Crna',bela:'Bela',siva:'Siva',antracit:'Antracit',braon:'Braon',plava:'Plava',teget:'Teget',crvena:'Crvena',srebrna:'Srebrna',zlatna:'Zlatna',srebrno_ogledalo:'Srebrno ogledalo',zlatno_ogledalo:'Zlatno ogledalo',srebrna_graverska:'Srebrna graverska',zlatna_graverska:'Zlatna graverska',crna_graverska:'Crna graverska',drvo_dezen:'Drvo dezen',cesljano_srebro:'Češljano srebro',srebrna_metalik:'Srebrna metalik',postansko_sanduce:'Poštansko sanduče',stan_plocica:'Pločica za vrata',cyrillic:'Ćirilica',latin:'Latinica',auto:'Prema unosu',right:'Desno',center:'Centar'};
  return names[text] || text.replaceAll('_', ' ');
}

export function normalizeCart(cart, lookup = {}, offers = []) {
  return (cart.items || []).map(item => {
    const metadata = lookup[String(item.product_id)] || {};
    const configured = offers.find(offer => Number(offer.productId) === Number(item.product_id));
    const props = item.properties || {};
    // `_kb_mesto` pamti za koje mesto je tabla radjena (sanduce, interfon). Ista
    // roba, razlicita namena — bez toga hotspot za interfon zauvek pokazuje „+".
    const category = props['_kb_mesto'] || metadata.category || categoryHandles[item.handle] || configured?.category || '';
    const preview = safeImage(props._preview_url || props['_customily-preview'] || props['_customily-thumb']);
    const svgPreview = safeImage(props._preview_svg_url);
    const brandedPreview = props._preview_style === 'branded_v1' && Boolean(preview);
    const personalized = Boolean(props._design_id || props._crm_design_url || preview || svgPreview || metadata.personalized || configured?.mode === 'editor');
    return {
      key: item.key, productId: item.product_id, variantId: item.variant_id || item.id,
      category, handle: item.handle || metadata.handle || '', title: item.product_title || item.title || '',
      quantity: Number(item.quantity || 0), price: Number(item.final_line_price ?? item.line_price ?? 0),
      variant: item.variant_title || '', preview, image: preview || safeImage(item.image || item.featured_image?.url),
      sceneImage: svgPreview || (!brandedPreview && preview) || (personalized ? '' : safeImage(item.image || item.featured_image?.url)),
      svgPreview, brandedPreview,
      properties: props,
      detailGroups: designDetailGroups(props),
      personalized, timestamp: Number(props._kb_ts || 0),
      style: ['Boja table', 'Boja teksta', 'Boja / materijal', 'Materijal', 'Vrata', 'Sa strane'].filter(key => props[key]).map(key => humanDesignValue(key, props[key]).slice(0, 100)).join(' + '),
      details: Object.entries(props).filter(([key, value]) => value && !key.startsWith('_') && !/telefon|email|e-mail|kontakt|napomena|^oblik$/i.test(key)).map(([key, value]) => `${humanDesignLabel(key)}: ${humanDesignValue(key, value)}`)
    };
  });
}

export function designDetailGroups(properties = {}) {
  const groups = [
    { title: 'Natpisi', rows: [] },
    { title: 'Materijali i boje', rows: [] },
    { title: 'Dimenzije i izrada', rows: [] }
  ];
  for (const [key, value] of Object.entries(properties)) {
    if (!value || key.startsWith('_') || /telefon|email|e-mail|kontakt|napomena|^oblik$/i.test(key)) continue;
    const group = /boja|materijal|vrata|sa strane/i.test(key) ? groups[1] : /tekst|natpis|prezime|^broj$|simbol|motiv/i.test(key) ? groups[0] : groups[2];
    group.rows.push({ label: humanDesignLabel(key), value: humanDesignValue(key, value) });
  }
  return groups.filter(group => group.rows.length);
}

export function quantityAttribution(item, quantity, touchId) {
  const props = {...(item.properties || {})};
  const saved = props._upsell_source === 'upotpunite-dom' ? Number(props._upsell_base_quantity) : NaN;
  const baseline = Number.isSafeInteger(saved) && saved >= 0 ? saved : item.quantity;
  return {...props, _upsell_source:'upotpunite-dom', _upsell_version:'v2', _upsell_category:item.category || '', _upsell_entry:props._upsell_entry || 'quantity', _upsell_touch_id:props._upsell_touch_id || touchId, _upsell_at:props._upsell_at || String(Date.now()), _upsell_base_quantity:String(Math.min(baseline, quantity))};
}

export function recommendationCategories(items, map, available) {
  const present = new Set(items.map(item => item.category).filter(Boolean));
  const preostali = [...new Set(available)].filter(category => !present.has(category));
  // `map` je do sada bio primljen ali ignorisan, pa su svi tipovi isli istim
  // redom svima. Sada se redosled uzima iz mape izvor -> ciljevi, ciji su parovi
  // prepisani iz `customer_brain_offers` (merena pouzdanja). Tipovi kojih nema u
  // mapi ostaju, samo idu iza — kupac i dalje vidi ceo asortiman.
  const izvor = [...items].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))[0]?.category;
  const preporuceni = (map && izvor && Array.isArray(map[izvor]) ? map[izvor] : [])
    .filter(category => preostali.includes(category));
  return [...preporuceni, ...preostali.filter(category => !preporuceni.includes(category))];
}

export function analyticsPayload(items, cart, offer, scene, before = cart.total_price) {
  const latest = [...items].sort((a, b) => b.timestamp - a.timestamp)[0];
  return {
    product_id: offer?.productId || null, variant_id: offer?.variantId || null,
    product_type: offer?.category || '', source_cart_product: latest?.productId || null,
    hotspot: offer?.category || '', scene, cart_value_before: Number(before || 0) / 100,
    cart_value_after: Number(cart.total_price || 0) / 100
  };
}

function node(tag, className, text) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
}

export class HomeUpsell {
  constructor(root) {
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-home-config]').textContent);
    this.cart = this.config.cart;
    this.text = this.config.text;
    this.offers = this.config.offers.filter(offer => offer.productId);
    this.lookup = this.config.lookup;
    this.dialog = root.querySelector('dialog');
    this.icons = root.querySelector('[data-home-icons]').content;
    this.busy = false;
    this.refreshing = false;
    this.cartRevision = 0;
    this.render();
    this.scena = this.config.activeScene || 'kuca';
    this.root.querySelectorAll('[data-home-scene]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.homeScene === this.scena)));
    try {
      const sacuvana = localStorage.getItem('kb_scena');
      if (sacuvana) this.prebaciScenu(sacuvana, false);
    } catch {}
    root.classList.add('kbh--ready');
    root.addEventListener('click', event => this.click(event));
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
    this.dialog.addEventListener('close', () => { this.stopModelSlider?.(); document.body.classList.remove('kbh-dialog-open'); this.opener?.focus(); });
    this.dialog.addEventListener('touchstart', event => { this.touchY = event.touches[0]?.clientY; }, { passive: true });
    this.dialog.addEventListener('touchend', event => {
      if (event.changedTouches[0]?.clientY - this.touchY > 90 && this.dialog.querySelector('[data-home-dialog-body]').scrollTop === 0) this.close();
    }, { passive: true });
    this.onFocus = () => this.refresh();
    window.addEventListener('focus', this.onFocus);
    this.onPageShow = event => { if (event.persisted) this.refresh(); };
    window.addEventListener('pageshow', this.onPageShow);
    this.cartUpdateEvent = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null;
    this.unsubscribe = typeof subscribe === 'function' && this.cartUpdateEvent ? subscribe(this.cartUpdateEvent, event => {
      if (event.source !== 'kb-home-upsell-v2') this.refresh();
    }) : null;
    this.track('home_upsell_view');
    this.refresh();
  }

  money(value) {
    return new Intl.NumberFormat('sr-RS', { style: 'currency', currency: this.cart.currency || this.config.currency || 'RSD', maximumFractionDigits: 0 }).format(Number(value || 0) / 100);
  }

  icon(category) { return this.icons.querySelector(`[data-home-icon="${category}"] svg`)?.cloneNode(true); }

  track(name, offer, before) {
    const payload = analyticsPayload(this.items, this.cart, offer, this.config.scene, before);
    try {
      window.KBUpsellAttribution?.emit(name, payload);
    } catch {}
  }

  // Drugi prolaz kroz konfigurator krece iz nule iako je kupac isti postupak
  // prosao pre dva minuta. Tri nivoa prenosa:
  //   "isti"   — jos jedan isti proizvod: boje, tekst, broj i dimenzija
  //   "srodan" — ista plocica na drugom mestu (vrata -> sanduce/interfon):
  //              boje, materijal i tekst DA, dimenzija NE — 15x4 i 6x2 nisu
  //              ista stvar; velicinu zadaje mesto na sceni (data-pw/data-ph)
  //   "drugi"  — drugi tip proizvoda: samo boje; „Cuvaj se psa" nema ulicu
  // Ako ciljni proizvod nema prenetu vrednost, setField je preskace.
  editorHref(offer, izvorItem, nivo) {
    if (offer.mode !== 'editor' || ['doormat', 'coasters'].includes(offer.category)) return offer.url;
    const poNovini = [...this.items].sort((x, y) => (y.timestamp || 0) - (x.timestamp || 0));
    // Za „srodan" nam treba artikal koji STVARNO ima natpis: ako je kupac posle
    // plocice dodao otirac, najnoviji artikal nema prezime koje bi se prenelo.
    const imaNatpis = v => v.properties && (v.properties['Natpis'] || v.properties['Prezime / natpis'] || v.properties['Gornji tekst']);
    const izvor = izvorItem || (nivo === 'srodan' ? poNovini.find(imaNatpis) : null) || poNovini[0];
    // Za „jos jedan isti" ciljamo bas taj proizvod, ne kategorijsku stranicu.
    const osnova = nivo === 'isti' && izvor && izvor.handle ? `/products/${izvor.handle}` : offer.url;
    const url = new URL(osnova, location.origin);
    url.searchParams.set('kb_cfg', '1');
    const p = izvor && izvor.properties;
    if (!p) return url.href;
    // Svaki tip table zove prezime drugacije: kucni broj „Natpis", plocica
    // „Prezime / natpis", sanduce „Gornji tekst".
    const tekst = p['Natpis'] || p['Prezime / natpis'] || p['Gornji tekst'] || '';
    const prenos = {
      kb_plate: p['Boja table'],
      kb_text: p['Boja teksta'],
      kb_dist: p['Distanceri'],
      kb_engraving: p['_kb_engraving']
    };
    if (nivo === 'isti' || nivo === 'srodan') {
      prenos.kb_street = tekst;
      prenos.kb_number = p['Broj'];
    }
    if (nivo === 'isti') {
      const mere = String(izvor.variant || '').match(/([\d.]+)\s*[x×]\s*([\d.]+)/i);
      if (mere) { prenos.kb_w = mere[1]; prenos.kb_h = mere[2]; }
    }
    if (nivo === 'srodan') prenos.kb_mesto = offer.category;
    Object.keys(prenos).forEach(k => { if (prenos[k]) url.searchParams.set(k, prenos[k]); });
    return url.href;
  }
  // Merenje preko GA4 pokriva ~26% sesija jer zavisi od pristanka na kolacice.
  // Atributi korpe prelaze na porudzbinu, pa se isto cita iz izvoza porudzbina
  // sa punom pokrivenoscu i bez pristanka.
  obelezi(dodatno) {
    const zeljeno = Object.assign({ _kb_upsell: '1', _kb_scena: this.config.activeScene || 'kuca' }, dodatno || {});
    const trenutno = (this.cart && this.cart.attributes) || {};
    const promena = {};
    Object.keys(zeljeno).forEach(k => { if (String(trenutno[k] || '') !== String(zeljeno[k])) promena[k] = zeljeno[k]; });
    if (!Object.keys(promena).length) return;
    const telo = JSON.stringify({ attributes: promena });
    try {
      // sendBeacon prezivljava odlazak sa stranice — klik na „Personalizujte"
      // odmah vodi u konfigurator i obican fetch bi bio prekinut.
      if (navigator.sendBeacon && navigator.sendBeacon('/cart/update.js', new Blob([telo], { type: 'application/json' }))) return;
    } catch {}
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: telo, keepalive: true }); } catch {}
  }

  // Pogadjanje scene po prvom artiklu je najcesce tacno, ali nije uvek: neko
  // kupi plocicu za kucu, ne za stan. Bez izlaza takvog kupca ne gubimo tiho
  // nego ljuto. Sve scene su vec iscrtane, pa prebacivanje ne trazi reload.
  prebaciScenu(kljuc, odKupca) {
    if (!kljuc || kljuc === this.scena) return;
    this.scena = kljuc;
    this.root.querySelectorAll('[data-home-scene-image]').forEach(pic => {
      const aktivna = pic.dataset.homeSceneImage === kljuc;
      pic.hidden = !aktivna;
      if (!aktivna) return;
      const img = pic.querySelector('img');
      const izvor = pic.querySelector('source');
      if (img && img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
      if (izvor && izvor.dataset.srcset) { izvor.srcset = izvor.dataset.srcset; delete izvor.dataset.srcset; }
    });
    this.root.querySelectorAll('[data-home-hotspot]').forEach(h => { h.hidden = h.dataset.scene !== kljuc; });
    this.root.querySelectorAll('[data-home-scene]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.homeScene === kljuc)));
    if (odKupca) {
      try { localStorage.setItem('kb_scena', kljuc); } catch {}
      this.obelezi({ _kb_scena: kljuc, _kb_scena_rucno: '1' });
      try { window.KBUpsellAttribution?.emit('home_upsell_scene_switch', { scena: kljuc }); } catch {}
    }
    this.render();
  }

  render() {
    this.items = normalizeCart(this.cart, this.lookup, this.offers);
    window.KBUpsellAttribution?.observe(this.cart);
    const empty = !this.items.length;
    this.root.querySelector('[data-home-empty]').hidden = !empty;
    this.root.querySelector('[data-home-layout]').hidden = empty;
    this.root.querySelector('[data-home-sticky]').hidden = empty;
    const wanted = recommendationCategories(this.items, this.config.recommendations, this.offers.map(offer => offer.category));
    const latestByCategory = category => this.items.filter(item => item.category === category).sort((a, b) => b.timestamp - a.timestamp)[0];
    this.root.querySelectorAll('[data-home-hotspot]').forEach(hotspot => {
      const category = hotspot.dataset.homeHotspot;
      const item = latestByCategory(category);
      const categoryItems = this.items.filter(value => value.category === category);
      const image = hotspot.querySelector('img');
      const badge = hotspot.querySelector('[data-home-sign]');
      const label = hotspot.querySelector('[data-home-label]');
      hotspot.classList.toggle('kbh__hotspot--present', Boolean(item));
      const example = !item && safeImage(hotspot.dataset.sceneExample);
      const sceneImage = item?.sceneImage || example;
      hotspot.classList.toggle('kbh__hotspot--image', Boolean(sceneImage));
      hotspot.classList.toggle('kbh__hotspot--example', Boolean(example));
      // Kvacica mora da bude SVG, ne znak '✓': tekstualni glif svaki
      // operativni sistem crta svojim fontom, pa na iPhone-u izgleda kao iOS.
      if (item) badge.innerHTML = '<svg class="kbh__glyph" viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 13l4.5 4.5L19 7"/></svg>'; else badge.textContent = '+';
      label.textContent = hotspot.dataset.label;
      // Dugacak dodatak („· 1 diz. / 2 kom.") je uz nowrap izbacivao pilulu van
      // scene. Broj komada je dovoljan; broj dizajna se vidi u korpi.
      const ukupnoKom = categoryItems.reduce((sum, value) => sum + value.quantity, 0);
      if (ukupnoKom > 1) label.textContent += ` ×${ukupnoKom}`;
      const price = hotspot.querySelector('[data-home-price]');
      if (price) { price.hidden = Boolean(item); price.textContent = `Od ${this.money(this.offers.find(offer => offer.category === category)?.price || 0)}`; }
      hotspot.setAttribute('aria-label', `${hotspot.dataset.label} — ${item ? this.text.inCart : this.text.view}`);
      if (sceneImage) {
        delete image.dataset.svgFallback;
        image.src = sizedImage(sceneImage, 600);
        image.alt = item ? item.title : hotspot.dataset.label;
        image.hidden = false;
        image.onerror = () => {
          if (item?.svgPreview && item.preview && !item.brandedPreview && image.dataset.svgFallback !== item.preview) {
            image.dataset.svgFallback = item.preview; image.src = sizedImage(item.preview, 600); return;
          }
          image.hidden = true; hotspot.classList.remove('kbh__hotspot--image', 'kbh__hotspot--example'); if (item) label.textContent = this.text.savedDesign;
        };
      } else { image.removeAttribute('src'); image.hidden = true; }
    });
    const list = this.root.querySelector('[data-home-items]');
    list.replaceChildren();
    this.items.forEach(item => {
      const li = node('li', 'kbh__cart-item');
      if (item.image) {
        const img = node('img'); img.src = sizedImage(item.image, 160); img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy';
        if (item.brandedPreview) { img.style.objectFit = 'contain'; img.style.background = '#f1efe9'; }
        img.onerror = () => { img.hidden = true; }; li.append(img);
      }
      const compactTitle = this.offers.find(offer => offer.category === item.category)?.label || item.title;
      const content = node('div'); const title = node('strong', '', compactTitle); title.title = item.title; content.append(title);
      if (item.variant && item.variant !== 'Default Title') content.append(node('span', 'kbh__muted', item.variant));
      // Kolicina se do sada samo ispisivala; za promenu je trebalo otici u korpu.
      // Isti ugovor kao u dijalogu: data-home-quantity = kljuc, data-quantity = nova.
      const kolicina = node('div', 'kbh__qty');
      [-1, 1].forEach(delta => {
        const dugme = node('button', 'kbh__qty-btn', delta < 0 ? '−' : '+');
        dugme.type = 'button';
        dugme.dataset.homeQuantity = item.key;
        dugme.dataset.quantity = item.quantity + delta;
        dugme.disabled = item.quantity + delta < 1;
        dugme.setAttribute('aria-label', (delta < 0 ? 'Smanjite kolicinu — ' : 'Povecajte kolicinu — ') + compactTitle);
        if (delta < 0) kolicina.append(dugme);
        else { kolicina.append(node('span', 'kbh__qty-num', String(item.quantity))); kolicina.append(dugme); }
      });
      content.append(kolicina);
      const remove = node('button', 'kbh__remove', 'Ukloni');
      remove.type = 'button'; remove.dataset.homeRemove = item.key;
      remove.setAttribute('aria-label', `Ukloni ${compactTitle} iz korpe`);
      if (item.details.length || item.preview) {
        const details = node('button', 'kbh__item-details kbh__details-button', 'Detalji dizajna');
        details.type = 'button'; details.dataset.homeOpen = item.category; details.dataset.homeDesign = item.key; content.append(details);
      }
      const actions = node('div', 'kbh__line-actions'); actions.append(node('strong', 'kbh__line-price', this.money(item.price)), remove);
      li.append(content, actions); list.append(li);
    });
    this.root.querySelectorAll('[data-home-total]').forEach(element => { element.textContent = this.money(this.cart.total_price); });
    // Postarina: sanduce = 600 RSD, bez njega = 400 RSD. Isto pravilo kao u
    // fioci korpe i u Liquid-u ove sekcije. Racuna se OVDE jer se iznosi menjaju
    // bez osvezavanja stranice; da je samo u Liquid-u, "Za naplatu" bi ostalo
    // zastarelo cim neko doda dodatak. Dodato 12.10.2026.
    const imaSanduce = (this.cart.items || []).some(stavka =>
      stavka.handle === 'postansko-sanduce' || categoryHandles[stavka.handle] === 'mailbox');
    const dostava = imaSanduce ? 60000 : 40000;
    this.root.querySelectorAll('[data-home-shipping]').forEach(element => { element.textContent = this.money(dostava); });
    this.root.querySelectorAll('[data-home-grand]').forEach(element => { element.textContent = this.money(Number(this.cart.total_price || 0) + dostava); });
    this.root.querySelectorAll('[data-home-costs]').forEach(element => { element.hidden = !this.cart.item_count; });
    this.root.querySelectorAll('[data-home-count]').forEach(element => { element.textContent = `${this.cart.item_count} ${this.text.items}`; });
    // Mozak je `wanted` vec poredjao po izmerenom pouzdanju, pa tim redom i
    // ispisujemo. Prve tri ostaju otvorene, ostale u presavijenom delu: osam
    // ponuda odjednom je previse izbora odmah posle kupovine.
    const kartice = [...this.root.querySelectorAll('[data-home-offer-card]')];
    const mreza = this.root.querySelector('.kbh__cards');
    let ostatak = this.root.querySelector('[data-home-rest]');
    if (!ostatak) {
      // Ostatak se NE sklanja iza klika: nekome treba bas taj proizvod. Vidljiv
      // je, samo tise — razlika je u isticanju, ne u dostupnosti.
      const omot = node('div', 'kbh__cards-rest');
      omot.append(node('p', 'kbh__rest-title', 'I sve ostalo što pravimo'));
      ostatak = node('div', 'kbh__cards'); ostatak.dataset.homeRest = '';
      omot.append(ostatak); mreza.after(omot);
    }
    kartice.forEach(card => {
      card.hidden = !empty && !wanted.includes(card.dataset.homeOfferCard);
      // Liquid `| money` daje „1,900.00 RSD" (format prodavnice), a ostatak
      // stranice „1.900 RSD". Ista cena, dva zapisa — izjednacavamo ovde.
      const cena = card.querySelector('.kbh__card-price');
      const ponuda = this.offers.find(o => o.category === card.dataset.homeOfferCard);
      if (cena && ponuda && Number(ponuda.price) > 0) cena.textContent = `${this.text.from || 'Od'} ${this.money(ponuda.price)}`;
    });
    const redosled = empty ? kartice.map(card => card.dataset.homeOfferCard) : wanted;
    redosled.forEach((category, index) => {
      const card = kartice.find(value => value.dataset.homeOfferCard === category);
      if (card) (index < 3 ? mreza : ostatak).append(card);
    });
    ostatak.parentElement.hidden = redosled.length <= 3;
    this.obelezi();
    const recommendations = this.root.querySelector('[data-home-recommendations]');
    recommendations.hidden = !empty && wanted.length === 0;
    const missing = this.root.querySelector('[data-home-missing]'); missing.replaceChildren();
    const more = node('details', 'kbh__more-products'); more.append(node('summary', '', 'Dodajte još proizvoda'));
    const choices = node('div', 'kbh__more-choices'); more.append(choices); missing.append(more);
    this.offers.forEach(offer => {
      const categoryPage = ['houseNumber', 'doorPlaque', 'doormat', 'coasters'].includes(offer.category);
      const button = node(categoryPage ? 'a' : 'button', 'kbh__missing', `+ ${offer.label}`);
      if (categoryPage) button.href = offer.url; else button.type = 'button';
      button.dataset.homeOpen = offer.category;
      const icon = this.icon(offer.category); if (icon) button.prepend(icon); choices.append(button);
    });
  }

  click(event) {
    const scena = event.target.closest('[data-home-scene]');
    if (scena) { event.preventDefault(); this.prebaciScenu(scena.dataset.homeScene, true); return; }
    const quantity = event.target.closest('[data-home-quantity]');
    if (quantity) { event.preventDefault(); this.changeQuantity(quantity.dataset.homeQuantity, Number(quantity.dataset.quantity)); return; }
    const remove = event.target.closest('[data-home-remove]');
    if (remove) { event.preventDefault(); this.remove(remove.dataset.homeRemove); return; }
    const open = event.target.closest('[data-home-open], [data-home-hotspot]');
    if (open && typeof this.dialog.showModal === 'function') {
      const category = open.dataset.homeOpen || open.dataset.homeHotspot;
      event.preventDefault(); this.open(category, open, Boolean(open.dataset.homeHotspot), open.dataset.homeDesign);
    }
    if (event.target.closest('[data-home-close]')) this.close();
    if (event.target.closest('[data-home-add]')) this.add();
    if (event.target.closest('[data-home-personalize]')) {
      window.KBUpsellAttribution?.begin(this.selected.category, this.opener?.dataset.homeHotspot ? 'hotspot' : 'popup');
      this.track('home_upsell_personalize_click', this.selected);
    }
    if (event.target.closest('[data-home-checkout]')) this.track('home_upsell_checkout_click');
  }

  open(category, opener, hotspot, selectedKey) {
    this.stopModelSlider?.();
    const offer = this.offers.find(value => value.category === category);
    if (!offer) return;
    this.selected = { ...offer };
    this.opener = opener;
    const categoryItems = this.items.filter(value => value.category === category).sort((a, b) => b.timestamp - a.timestamp);
    const item = categoryItems.find(value => value.key === selectedKey) || categoryItems[0];
    this.activeCategory = category; this.activeKey = item?.key;
    this.dialog.classList.toggle('kbh__dialog--saved', Boolean(item));
    const body = this.dialog.querySelector('[data-home-dialog-body]'); body.replaceChildren();
    body.append(node('p', 'kbh__eyebrow', item ? this.text.inCart : this.text.detail));
    const heading = node('h2', 'kbh__modal-title', offer.label || offer.title); heading.id = `kbh-title-${this.config.sectionId}`; body.append(heading);
    // Cena je do sada postojala samo na piluli u sceni; u dijalogu je nestajala,
    // bas u trenutku kad kupac odlucuje. Klasa .kbh__modal-price je vec bila
    // stilizovana ali nekoriscena.
    if (!item && Number(offer.price) > 0) {
      const dostupne = (offer.variants || []).filter(v => v.available).map(v => Number(v.price));
      const raspon = dostupne.length > 1 && Math.min(...dostupne) !== Math.max(...dostupne);
      const odTekst = raspon ? (this.text.from ? this.text.from + ' ' : 'Od ') : '';
      body.append(node('p', 'kbh__modal-price', odTekst + this.money(offer.price)));
    }
    if (categoryItems.length > 1) {
      const select = node('select', 'kbh__design-picker'); select.setAttribute('aria-label', 'Izaberite dizajn iz korpe');
      categoryItems.forEach((value, index) => {
        const caption = value.detailGroups.find(group => group.title === 'Natpisi')?.rows.map(row => row.value).join(' · ') || value.variant || value.title;
        const option = node('option', '', `${index + 1}. ${caption} — ${value.quantity} kom.`); option.value = value.key; select.append(option);
      });
      select.value = item.key; select.addEventListener('change', () => this.open(category, opener, false, select.value)); body.append(select);
    }
    const modelSource = ['houseNumber', 'doorPlaque'].includes(category)
      ? this.root.querySelector(`[data-home-offer-card="${category}"] .kbh__model-slider`) : null;
    const src = item ? (item.brandedPreview ? item.preview : item.sceneImage) : (!modelSource && safeImage(offer.image));
    if (src) {
      const img = node('img', `kbh__modal-image${item ? ' kbh__modal-image--saved' : ''}`);
      img.src = sizedImage(src, 600); img.alt = item ? `Vaš dizajn: ${offer.label || offer.title}` : offer.title;
      img.dataset.category = category; img.width = 520; img.height = 360;
      if (item?.brandedPreview) { img.style.height = 'auto'; img.style.maxHeight = 'none'; img.style.objectFit = 'contain'; }
      let fallback = false;
      img.onerror = () => {
        if (!fallback && item?.svgPreview && item.preview && src !== item.preview) { fallback = true; img.src = sizedImage(item.preview, 600); return; }
        img.hidden = true;
      };
      body.append(img);
      if (item?.brandedPreview) {
        const full = node('a', 'kbh__item-details kbh__details-button', 'Otvorite celu sliku dizajna ↗');
        full.href = item.preview; full.target = '_blank'; full.rel = 'noopener noreferrer';
        full.setAttribute('aria-label', 'Otvorite celu sliku svog dizajna u novom tabu'); body.append(full);
      }
    }
    if (modelSource && !item) {
      const slider = modelSource.cloneNode(true);
      slider.classList.add('kbh__modal-slider');
      slider.dataset.category = category;
      slider.querySelectorAll('img').forEach(img => {
        img.loading = 'eager';
        img.onerror = () => { img.hidden = true; };
      });
      body.append(this.enhanceModelSlider(slider));
    }
    if (!item) body.append(node('p', 'kbh__description', offer.description));
    const style = this.items.find(value => value.category === 'houseNumber' && value.style)?.style;
    if (!item && style && offer.mode === 'editor') {
      const source = this.items.filter(value => value.category === 'houseNumber' && value.style).sort((a,b) => b.timestamp-a.timestamp)[0];
      const hint = node('div', 'kbh__style-hint');
      hint.append(node('strong', '', offer.category === 'doormat' ? 'Vaš postojeći stil' : 'Uskladite sa svojim kućnim brojem'));
      if (source.svgPreview || source.image) { const img = node('img', 'kbh__style-preview'); img.src = sizedImage(source.svgPreview || source.image, 300); img.alt = 'Vaš izabrani kućni broj'; img.onerror = () => { img.hidden = true; }; hint.append(img); }
      hint.append(node('p', '', source.style),node('small', '', offer.category === 'doormat' ? 'Inspiracija za vaš natpis i motiv. Personalizaciju birate na stranici proizvoda.' : 'Boje i tekst potvrđujete u editoru.')); body.append(hint);
    }
    if (item) {
      const details = node('div', 'kbh__design-details');
      const tabs = node('div', 'kbh__detail-tabs'); tabs.setAttribute('role', 'tablist'); tabs.setAttribute('aria-label', 'Detalji izabranog dizajna'); details.append(tabs);
      item.detailGroups.forEach((group, index) => {
        const tab = node('button', '', group.title === 'Dimenzije i izrada' ? 'Izrada' : group.title === 'Materijali i boje' ? 'Boje' : 'Natpisi');
        tab.type = 'button'; tab.setAttribute('role', 'tab'); tab.id = `kbh-detail-tab-${index}`; tab.setAttribute('aria-selected', String(index === 0));
        const section = node('section', 'kbh__detail-group');
        section.hidden = index !== 0; section.id = `kbh-detail-panel-${index}`; section.setAttribute('role', 'tabpanel'); section.setAttribute('aria-labelledby', tab.id); tab.setAttribute('aria-controls', section.id);
        const list = node('dl');
        group.rows.forEach(row => { const entry = node('div'); const value = node('dd', '', row.value); value.title = row.value; entry.append(node('dt', '', row.label), value); list.append(entry); });
        tab.addEventListener('click', () => { details.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel !== section; }); tabs.querySelectorAll('button').forEach(button => button.setAttribute('aria-selected', String(button === tab))); });
        tabs.append(tab);
        section.append(list); details.append(section);
      });
      body.append(details);
      const controls = node('div', 'kbh__design-actions');
      const quantity = node('div', 'kbh__quantity'); quantity.setAttribute('aria-label', 'Količina istog dizajna');
      for (const delta of [-1, 1]) {
        const button = node('button', '', delta < 0 ? '−' : '+'); button.type = 'button'; button.dataset.homeQuantity = item.key; button.dataset.quantity = String(item.quantity + delta); button.disabled = delta < 0 && item.quantity <= 1;
        button.setAttribute('aria-label', delta < 0 ? 'Smanjite količinu' : 'Povećajte količinu');
        if (delta > 0) quantity.append(node('span', '', `${item.quantity} kom.`)); quantity.append(button);
      }
      const remove = node('button', 'kbh__remove', 'Ukloni dizajn'); remove.type = 'button'; remove.dataset.homeRemove = item.key;
      controls.append(quantity, remove); body.append(controls);
      const another = node('a', 'kbh__button kbh__button--primary', 'Dodajte još jedan dizajn'); another.href = this.editorHref(offer, item, 'isti'); another.addEventListener('click', () => this.obelezi({ _kb_prenos: 'isti' })); another.dataset.homePersonalize = ''; body.append(another);
    }
    if (!item && offer.mode === 'direct') {
      const label = node('label', 'kbh__variant-label', this.text.variant); const select = node('select', 'kbh__variant');
      select.id = `kbh-variant-${this.config.sectionId}`; label.htmlFor = select.id;
      offer.variants.forEach(variant => { const option = node('option', '', `${variant.title} — ${this.money(variant.price)}`); option.value = variant.id; option.disabled = !variant.available; select.append(option); });
      const variant = offer.variants.find(value => value.available); select.value = variant?.id || '';
      this.selected.variantId = Number(variant?.id || 0);
      select.addEventListener('change', () => {
        this.selected.variantId = Number(select.value);
      });
      body.append(label, select);
      const add = node('button', 'kbh__button kbh__button--primary', variant ? this.text.add : this.text.unavailable);
      add.type = 'button'; add.dataset.homeAdd = ''; add.disabled = !variant; body.append(add);
    }
    if (!item) {
      const link = node('a', `kbh__button${offer.mode === 'editor' ? ' kbh__button--primary' : ''}`, offer.mode === 'editor' ? this.config.personalizeCta : this.text.fullProduct);
      // Hotspot sam kaze koliko sme da prenese: „Plocica za interfon" je ista
      // plocica kao na vratima, pa nosi i prezime; „Cuvaj se psa" ne nosi.
      const nivoPrenosa = (this.opener && this.opener.dataset.carry) || 'drugi';
      link.href = this.editorHref(offer, null, nivoPrenosa);
      link.addEventListener('click', () => this.obelezi({ _kb_prenos: nivoPrenosa }));
      if (offer.mode === 'editor') link.dataset.homePersonalize = '';
      body.append(link);
    }
    const message = node('p', 'kbh__feedback'); message.dataset.homeMessage = ''; message.setAttribute('role', 'status'); body.append(message);
    if (!this.dialog.open) this.dialog.showModal(); document.body.classList.add('kbh-dialog-open');
    body.scrollTop = 0;
    if (hotspot) this.track('home_upsell_hotspot_click', this.selected);
    this.track('home_upsell_product_view', this.selected);
  }

  enhanceModelSlider(slider) {
    const images = [...slider.querySelectorAll('img')];
    const gallery = node('div', 'kbh__model-gallery');
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-label', 'Pregled modela');
    gallery.tabIndex = 0;
    slider.classList.add('kbh__modal-slider--interactive');
    const caption = node('p', 'kbh__model-caption');
    const controls = node('div', 'kbh__model-controls');
    const dots = node('div', 'kbh__model-dots');
    const previous = node('button', 'kbh__model-arrow', '‹');
    const next = node('button', 'kbh__model-arrow', '›');
    const pause = node('button', 'kbh__model-pause', 'Zaustavi');
    [previous, next, pause].forEach(button => { button.type = 'button'; });
    previous.setAttribute('aria-label', 'Prethodni model');
    next.setAttribute('aria-label', 'Sledeći model');
    let index = 0, timer = null;
    let playing = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const buttons = images.map((image, position) => {
      const button = node('button', 'kbh__model-dot');
      button.type = 'button';
      button.setAttribute('aria-label', image.alt);
      button.addEventListener('click', () => { playing = false; stop(); show(position); });
      dots.append(button);
      return button;
    });
    function show(position) {
      index = (position + images.length) % images.length;
      images.forEach((image, i) => {
        image.classList.toggle('is-active', i === index);
        image.setAttribute('aria-hidden', String(i !== index));
      });
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      caption.textContent = images[index].alt + ' · ' + (index + 1) + ' / ' + images.length;
      pause.textContent = playing ? 'Zaustavi' : 'Pokreni';
      pause.setAttribute('aria-label', playing ? 'Zaustavi automatsku smenu modela' : 'Pokreni automatsku smenu modela');
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() { stop(); if (playing) timer = setInterval(() => show(index + 1), 5000); }
    function move(direction) { playing = false; stop(); show(index + direction); }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    pause.addEventListener('click', () => { playing = !playing; show(index); start(); });
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) start(); });
    controls.append(previous, dots, next);
    gallery.append(slider, caption, controls, pause);
    this.stopModelSlider = stop;
    show(0); start();
    return gallery;
  }

  close() { this.dialog.close(); document.body.classList.remove('kbh-dialog-open'); }

  async changeQuantity(key, quantity) {
    if (this.busy || !Number.isSafeInteger(quantity) || quantity < 1 || !this.items.some(item => item.key === key)) return;
    this.busy = true; this.cartRevision = (this.cartRevision || 0) + 1;
    const feedback = this.root.querySelector('[data-home-feedback]');
    const previous = this.items.find(item => item.key === key);
    const attributedProperties = quantityAttribution(previous, quantity, previous.properties?._upsell_touch_id || window.crypto.randomUUID());
    this.dialog.querySelectorAll('[data-home-quantity], [data-home-remove]').forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(`${this.config.root}cart/change.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,properties:attributedProperties,sections:['cart-icon-bubble'],sections_url:location.pathname})});
      const cart = await response.json(); if (!response.ok || !Array.isArray(cart.items)) throw new Error('quantity failed');
      this.cart = cart; this.render();
      const bubble = cart.sections?.['cart-icon-bubble'];
      if (bubble && document.getElementById('cart-icon-bubble')) document.getElementById('cart-icon-bubble').innerHTML = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section')?.innerHTML || bubble;
      if (typeof publish === 'function' && this.cartUpdateEvent) publish(this.cartUpdateEvent, {source:'kb-home-upsell-v2',cartData:cart});
      const updated = this.items.find(item => item.properties._upsell_touch_id === attributedProperties._upsell_touch_id) || this.items.find(item => item.key === key);
      if (this.dialog.open) this.open(this.activeCategory, this.opener, false, updated?.key);
      window.KBUpsellAttribution?.emit('home_upsell_quantity_change', {product_id:previous.productId,product_type:previous.category,quantity_before:previous.quantity,quantity:updated?.quantity || quantity,quantity_delta:(updated?.quantity || quantity)-previous.quantity});
      feedback.textContent = 'Količina je ažurirana.';
    } catch {
      feedback.textContent = 'Količina nije promenjena. Pokušajte ponovo.';
      const message = this.dialog.querySelector('[data-home-message]'); if (message) message.textContent = feedback.textContent;
      this.dialog.querySelectorAll('[data-home-quantity], [data-home-remove]').forEach(button => { button.disabled = button.dataset.homeQuantity ? Number(button.dataset.quantity) < 1 : false; });
    } finally { this.busy = false; }
  }

  async remove(key) {
    if (this.busy) return;
    const index = this.items.findIndex(item => item.key === key);
    if (index < 0) return;
    const item = this.items[index];
    this.busy = true;
    this.cartRevision = (this.cartRevision || 0) + 1;
    const feedback = this.root.querySelector('[data-home-feedback]');
    this.root.querySelectorAll('[data-home-remove]').forEach(button => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
    feedback.textContent = 'Uklanjamo artikal…';
    try {
      const response = await fetch(`${this.config.root}cart/change.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: ['cart-icon-bubble'], sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error('remove failed');
      this.cart = cart; this.render();
      if (this.dialog?.open) {
        if (this.items.some(value => value.category === this.activeCategory)) this.open(this.activeCategory, this.opener, false, this.activeKey);
        else this.close();
      }
      const bubble = cart.sections?.['cart-icon-bubble'];
      if (bubble && document.getElementById('cart-icon-bubble')) document.getElementById('cart-icon-bubble').innerHTML = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section')?.innerHTML || bubble;
      if (typeof publish === 'function' && this.cartUpdateEvent) publish(this.cartUpdateEvent, { source: 'kb-home-upsell-v2', cartData: this.cart });
      feedback.textContent = `Uklonjeno iz korpe — ${item.title}`;
      window.KBUpsellAttribution?.emit('home_upsell_remove', {product_id:item.productId,product_type:item.category,quantity:item.quantity});
      const controls = this.root.querySelectorAll('[data-home-remove]');
      const next = controls[Math.min(index, controls.length - 1)] || this.root.querySelector('[data-home-empty] a');
      next?.focus();
    } catch {
      feedback.textContent = 'Artikal nije uklonjen. Pokušajte ponovo.';
    } finally {
      this.busy = false;
      this.root.querySelectorAll('[data-home-remove]').forEach(button => { button.disabled = false; button.removeAttribute('aria-disabled'); });
    }
  }

  async refresh() {
    if (this.refreshing || this.busy) return;
    this.refreshing = true;
    const revision = this.cartRevision;
    try {
      const response = await fetch(`${this.config.root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!this.busy && revision === this.cartRevision) { this.cart = cart; this.render(); }
    } catch {} finally { this.refreshing = false; }
  }

  async add() {
    if (this.busy || this.selected?.mode !== 'direct' || !this.selected.variantId) return;
    this.busy = true;
    this.cartRevision = (this.cartRevision || 0) + 1;
    const offer = { ...this.selected };
    const before = this.cart.total_price;
    const button = this.dialog.querySelector('[data-home-add]');
    button.disabled = true; button.textContent = this.text.adding;
    const feedback = this.root.querySelector('[data-home-feedback]');
    let added = false;
    try {
      const response = await fetch(`${this.config.root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: offer.variantId, quantity: 1, properties: {_upsell_source:'upotpunite-dom',_upsell_version:'v2',_upsell_category:offer.category,_upsell_entry:'direct',_upsell_touch_id:window.crypto.randomUUID(),_upsell_base_quantity:'0'} }], sections: ['cart-icon-bubble'], sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(this.text.error);
      added = true;
      const cartResponse = await fetch(`${this.config.root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok) throw new Error(this.text.refreshError);
      this.cart = await cartResponse.json(); this.render();
      const bubble = result.sections?.['cart-icon-bubble'];
      if (bubble && document.getElementById('cart-icon-bubble')) document.getElementById('cart-icon-bubble').innerHTML = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section')?.innerHTML || bubble;
      if (typeof publish === 'function' && this.cartUpdateEvent) publish(this.cartUpdateEvent, { source: 'kb-home-upsell-v2', cartData: this.cart });
      feedback.textContent = `${this.text.added} — ${offer.label}`;
      this.close();
    } catch {
      feedback.textContent = added ? this.text.refreshError : this.text.error;
      const message = this.dialog.querySelector('[data-home-message]'); if (message) message.textContent = feedback.textContent;
      if (added) {
        button.textContent = this.text.added;
        const link = node('a', 'kbh__button', this.text.editCart); link.href = this.config.cartUrl; button.after(link);
      } else { button.disabled = false; button.textContent = this.text.add; }
    } finally { this.busy = false; }
  }

  destroy() {
    window.removeEventListener('focus', this.onFocus); window.removeEventListener('pageshow', this.onPageShow);
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
    if (this.dialog.open) this.close();
  }
}

if (typeof document !== 'undefined') {
  const initialize = scope => scope.querySelectorAll('[data-home-upsell]').forEach(root => {
    if (root.homeUpsell) return;
    try {
      root.homeUpsell = new HomeUpsell(root);
    } catch (e) {
      // Ranije je ova greska bila progutana: komponenta bi nestala, stranica bi
      // ostala staticna slika i nijedan dogadjaj ne bi otisao — bez ikakvog traga.
      root.classList.remove('kbh--ready');
      if (window.console && console.error) console.error('[kb-home-upsell] inicijalizacija nije uspela:', e);
      try { window.KBUpsellAttribution?.emit('home_upsell_init_error', { message: String(e && e.message || e) }); } catch {}
    }
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-home-upsell]').forEach(root => root.homeUpsell?.destroy()));
}

